var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackPause = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-PlaybackPause Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#484848",
  fillOpacity: 0.6,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12 28.725v-17.45c0-.704.57-1.275 1.275-1.275h3.103c.704 0 1.275.57 1.275 1.275v17.45c0 .704-.571 1.275-1.275 1.275h-3.103C12.571 30 12 29.43 12 28.725m10.347 0v-17.45c0-.704.571-1.275 1.275-1.275h3.103c.704 0 1.275.57 1.275 1.275v17.45c0 .704-.57 1.275-1.275 1.275h-3.103c-.704 0-1.275-.57-1.275-1.275"
})))));
export default SvgPlaybackPause;